var logoAnimationStart = false;

function logoAnimation() {
    if (logoAnimationStart)
        return false;
    
    logoAnimationStart = true;
    
    var
        tl = new gsap.timeline(),
        j  = 0;
        
    var 
        objects = {
            caret  : $(".logo__caret"),
            letters: $(".logo__letters span")
        };
    
    var 
        options = {
            blinkSpeed   : 0.3,
            caretDelay   : 0.1,
            movementEase : Expo.easeIn,
            movementSpeed: 0.02
        };
    
    tl.fromTo(objects.caret, options.blinkSpeed, {opacity: 0}, {opacity: 1, repeat: 2, yoyo: true});

    for (var i = 0; i < objects.letters.length; i++) {
        if (i < 7 || i > 7) {
            tl.to(objects.caret, options.movementSpeed, {
                left      : objects.caret.width() * i,
                delay     : options.caretDelay,
                ease      : options.movementEase,
                onComplete: function() {
                    if (j != 6)
                        objects.letters.eq(j).css('opacity', 1);
                    
                    j++;
                    
                    if (j === 10)
                        gsap.to(objects.caret, options.movementSpeed, {left: objects.caret.width() * i, delay: 0.1});
                }
            });
        } else {
            tl.fromTo(objects.caret, options.blinkSpeed, {opacity: 1}, {opacity: 0, repeat: 1, yoyo: true, 
                onComplete: function() {
                    objects.letters.eq(6).css('opacity', 1);
                    objects.letters.eq(j).css('opacity', 1);
                    j++;
                }
            });
        }
    }
    
    tl.fromTo(objects.caret, options.blinkSpeed, {opacity: 1}, {opacity: 0, repeat: 3, yoyo: true});
    
    tl.to(objects.caret, options.blinkSpeed, {
        left: 0, 
        onComplete: function() {
            objects.letters.eq(0).css('color', '#fff');
            $('body').removeClass('is-preloading');
            $('.logo').addClass('logo--mobile-fly');
        }
    });
};

function toggleOverlayMenu(event) {
    $('body').toggleClass("is-overlay-menu");
    $(event.currentTarget).closest('.navigation-btn').toggleClass("is-active");
}

function closeOverlayMenu(event) {
    $('body').removeClass("is-overlay-menu");
    $(event.currentTarget).closest('.navigation-btn').removeClass("is-active");
}

function updateMeta(page) {
    const defaultTitle = "SimpleCode — Разработка программного обеспечения";
 
    const newTitle = page.data('title') || defaultTitle;

    document.title = 'SimpleCode — ' + newTitle.replace('SimpleCode — ', '');
}

function normalizePath(path) {
    if (!path) return '/';

    if (path.endsWith('/') && path !== '/') {
        path = path.slice(0, -1);
    }

    if (path === '/index') {
        history.replaceState({}, '', '/');
        return '/';
    }

    return path;
}

function openPage(path, push = true) {
    path = normalizePath(path);

    // /portfolio/wosh → #portfolio-wosh
    let id = '#index';
    if (path !== '/') {
        id = '#' + path.replace(/^\//, '').replace(/\//g, '-');
    }

    $('.page, .navigation').removeClass('is-active');

    let page = $(id);
    page.addClass('is-active');

    switch (id) {
        case '#index':
            $('body').removeClass('is-inner is-white');
            break;

        case '#catalog':
            $('body').addClass('is-white is-inner');
            break;

        default:
            $('body').addClass('is-inner').removeClass('is-white');
    }

    updateMeta(page);

    // Обновление URL
    if (push) history.pushState({}, '', path);
}

function slider(slider) {
    slider.each(function(index, item){
        var slider = $(item),
            sliderTrack = slider.find('.slider-track'),
            sliderEl = slider.find('.slider-item'),
            sliderElQty = sliderEl.length,
            nav = slider.find('.slider-nav');

        sliderEl.eq(0).addClass('is-active');

        for (var i = 0; i < sliderElQty; i++) {
            let item = sliderEl.eq(i);
            
            const li = $('<li>');
            const a = $('<a>', { href: "#" });
            
            const span = $('<span>');
            span.addClass('hidden-xs');
            span.css('padding-right', '20px');
            span.text(item.data('caption'));

            const icon = $('<i>');
            icon.addClass(item.data('icon'));
            
            a.append(span);
            a.append(icon);
            li.append(a);
            nav.append(li);
        }

        var navEl = nav.find('li');

        navEl.eq(0).addClass('is-active');

        navEl.each(function(){
            $(this).on('click', function(){
                var navElIndx = $(this).index();

                sliderTrack.css('transform', 'translateX(-'+ navElIndx*100 +'%)');
                navEl.removeClass('is-active').eq(navElIndx).addClass('is-active');
                sliderEl.removeClass('is-active').eq(navElIndx).addClass('is-active');
                return false;
            });
        });
    });
}

function rslider(slider, content) {
    const items = content.find('.solutions__item');
    const prevBtn = slider.find('.pager__item--prev');
    const nextBtn = slider.find('.pager__item--next');

    let index = items.index($('.solutions__item.active'));
    if (index === -1) index = 0;

    nextBtn.on('click', function (e) {
        e.preventDefault();
        const newIndex = (index + 1) % items.length;
        activateItem(newIndex, 'next');
        return false;
    });

    prevBtn.on('click', function (e) {
        e.preventDefault();
        const newIndex = (index - 1 + items.length) % items.length;
        activateItem(newIndex, 'prev');
        return false;
    });

    function activateItem(newIndex, direction) {
        const current = items.eq(index);
        const nextItem = items.eq(newIndex);

        if (current[0] === nextItem[0]) return;

        if (direction === 'next') {
            current.removeClass('active').addClass('fly-up');
            setTimeout(() => {
                current.removeClass('fly-up').addClass('instant-hide');
                setTimeout(() => {
                    current.removeClass('instant-hide');
                }, 250);                
            }, 250);

            nextItem.addClass('instant-hide');
            setTimeout(() => {
                nextItem.removeClass('instant-hide').addClass('active');
            }, 20);
        }

        if (direction === 'prev') {
            current.removeClass('active').addClass('fly-down');
            setTimeout(() => {
                current.removeClass('fly-down').addClass('instant-hide');
                setTimeout(() => {
                    current.removeClass('instant-hide');
                }, 250);                
            }, 250);

            nextItem.addClass('instant-hide-top');
            setTimeout(() => {
                nextItem.removeClass('instant-hide-top').addClass('active');
            }, 20);
        }

        index = newIndex;
    }
}

function vslider(slider) {
    var slider = slider,
        sliderTrack = slider.find('.vslider-track'),
        sliderEl = slider.find('.vslider-item'),
        sliderElQty = sliderEl.length,
        sliderElActive = 0,
        sliderElHeight = sliderEl.outerHeight(),
        pagerPrev = slider.closest('.page').find('.pager__item--prev'),
        pagerNext = slider.closest('.page').find('.pager__item--next');

    sliderEl.eq(0).addClass('is-active');


    pagerPrev.on('click', function(){

        if (sliderElActive > 0 && sliderElActive <= sliderElQty){
            console.log('yes');
            sliderElActive = sliderElActive - 1;
            transform = sliderElActive*sliderElHeight;
            sliderTrack.css('transform', 'translateY(-' + transform +'px)');
            sliderEl.removeClass('is-active');
            sliderEl.eq(sliderElActive).addClass('is-active');
        } else {
            console.log('no');
        }

        return false;
    });

    pagerNext.on('click', function(){

        if (sliderElActive >= 0 && sliderElActive < (sliderElQty - 1) ){
            console.log('yes');
            sliderElActive = sliderElActive + 1;
            transform = sliderElActive*sliderElHeight;
            sliderTrack.css('transform', 'translateY(-' + transform +'px)');
            sliderEl.removeClass('is-active');
            sliderEl.eq(sliderElActive).addClass('is-active');
        }

        return false;
    });

}

function parallaxScroll(event) {
    const parallax = $(event.currentTarget);
    const scrollTop = parallax.scrollTop();

    parallax.find('.js-parallax').each(function () {
        const el = $(this);
        const wrap = el.closest('.js-parallax-wrap');

        const boxScrollTop = wrap.position().top; 
        const boxOffset = el.data('offset') || 0;
        const speed = el.data('speed') || 0.5;

        const offset = scrollTop - (boxScrollTop - boxOffset);

        el.css('transform', 'translateY(-' + (offset * speed) + 'px)');
    });
}

function isInViewport(el, offset) {
    const rect = el[0].getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    return rect.top + offset <= windowHeight;
}

function animateOnScroll(arg) {
    let aos;

    if (arg && arg.currentTarget) {
        aos = $(arg.currentTarget);
    } else if (arg instanceof Element) {
        aos = $(arg);
    } else if (this instanceof Element) {
        aos = $(this);
    }

    aos.find('.js-aos').each(function () {
        const el = $(this);
        const elOffset = el.data('offset') || 0;

        if (isInViewport(el, elOffset)) {
            el.addClass('is-animated');
        } else {
            el.removeClass('is-animated');
        }
    });
}

function updateTime() {
    const now = new Date();

    // Локальное время браузера
    const local = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    });

    // Время Москвы
    const moscow = now.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Moscow'
    });

    document.getElementById('localTime').textContent = local;
    document.getElementById('moscowTime').textContent = moscow;

    // обновляем аналоговые часы ---
    const moscowDate = new Date(
        now.toLocaleString("en-US", { timeZone: "Europe/Moscow" })
    );

    updateAnalogClock("localClock", now);
    updateAnalogClock("moscowClock", moscowDate);
}

function blinkColons() {
    const localEl = document.getElementById('localTime');
    const moscowEl = document.getElementById('moscowTime');

    // Берём текущий текст
    const localText = localEl.textContent;
    const moscowText = moscowEl.textContent;

    // Если двоеточие видно — скрываем, если скрыто — показываем
    localEl.textContent = localText.includes(':')
        ? localText.replace(':', ' ')
        : localText.replace(' ', ':');

    moscowEl.textContent = moscowText.includes(':')
        ? moscowText.replace(':', ' ')
        : moscowText.replace(' ', ':');
}

function updateAnalogClock(clockId, dateObj) {
    const hours = dateObj.getHours() % 12;
    const minutes = dateObj.getMinutes();

    const hourAngle = hours * 30 + minutes * 0.5;
    const minuteAngle = minutes * 6;

    const hourHand = document.querySelector(`#${clockId} .hourHand`);
    const minuteHand = document.querySelector(`#${clockId} .minuteHand`);

    hourHand.setAttribute("transform", `rotate(${hourAngle} 50 50)`);
    minuteHand.setAttribute("transform", `rotate(${minuteAngle} 50 50)`);
}

$(function() {
    logoAnimation();
    
    $('.logo a').on('click', function(event) {
        event.preventDefault();
    });

	$('.js-toggle-inner-page').on('click', function(event) {
        $('body').toggleClass('is-inner');
        $('.navigation').removeClass('is-active');
	});

	$('.js-toggle-menu').on('click', toggleOverlayMenu);

    $('.parallax').on('scroll', parallaxScroll);
    $('.aos').on('scroll', animateOnScroll);

    $('.js-tabs-link').on('click', function () {
		var el = $(this),
			tabs = el.closest('.js-tabs'),
			id = el.attr('data-tab');

		tabs.find('[data-tab]').removeClass('is-active');
		tabs.find('[data-tab= ' + id + ']').addClass('is-active');
	});

    $('.lnk').on('click', function(event){
        event.preventDefault();
        const path = normalizePath($(this).attr('href'));
        closeOverlayMenu(event);
        openPage(path, true);

        return false;
    });

    window.addEventListener('popstate', function() {
        openPage(location.pathname, false);
    });

    $(document).ready(function() {
        openPage(location.pathname, false);
        $('.aos').each(animateOnScroll);
    });

    $(window).on('resize', function() {
        $('.aos').each(animateOnScroll);
    });

    vslider($('#portfolioSlider'));
    slider($('#company'));
    rslider($('#solutions-pager'), $('#solutions_content'));

    // Первый запуск сразу
    updateTime();

    // Обновление раз в минуту
    setInterval(updateTime, 60 * 1000);

    // Запускаем моргание каждую секунду
    setInterval(blinkColons, 1000);
});